<template>
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1746 10.1531C12.0354 10.1531 11.9018 10.2084 11.8034 10.3069C11.7049 10.4054 11.6496 10.5389 11.6496 10.6781C11.6496 10.8174 11.7049 10.9509 11.8034 11.0494C11.9018 11.1478 12.0354 11.2031 12.1746 11.2031H14.2746C14.4138 11.2031 14.5474 11.1478 14.6458 11.0494C14.7443 10.9509 14.7996 10.8174 14.7996 10.6781C14.7996 10.5389 14.7443 10.4054 14.6458 10.3069C14.5474 10.2084 14.4138 10.1531 14.2746 10.1531H12.1746ZM0.0996094 3.59063C0.0996094 2.82481 0.403827 2.09037 0.945339 1.54885C1.48685 1.00734 2.2213 0.703125 2.98711 0.703125H14.0121C14.7779 0.703125 15.5124 1.00734 16.0539 1.54885C16.5954 2.09037 16.8996 2.82481 16.8996 3.59063V10.4156C16.8996 11.1814 16.5954 11.9159 16.0539 12.4574C15.5124 12.9989 14.7779 13.3031 14.0121 13.3031H2.98711C2.2213 13.3031 1.48685 12.9989 0.945339 12.4574C0.403827 11.9159 0.0996094 11.1814 0.0996094 10.4156V3.59063ZM2.98711 1.75313C2.49977 1.75313 2.0324 1.94672 1.6878 2.29132C1.3432 2.63591 1.14961 3.10329 1.14961 3.59063V4.90313H15.8496V3.59063C15.8496 3.10329 15.656 2.63591 15.3114 2.29132C14.9668 1.94672 14.4994 1.75313 14.0121 1.75313H2.98711ZM15.8496 5.95313H1.14961V10.4156C1.14961 11.4299 1.97281 12.2531 2.98711 12.2531H14.0121C14.4994 12.2531 14.9668 12.0595 15.3114 11.7149C15.656 11.3703 15.8496 10.903 15.8496 10.4156V5.95313Z"
    />
  </svg>
</template>

<script>
export default {
  name: "PaymentIcon",
};
</script>

<style></style>
